const globalActivityAreasHelper = {
  'Software Technologies': 'Software Technologies',
  'Yazılım ve Bilişim Teknolojileri': 'Software Technologies',

  'E-Commerce': 'E-Commerce',
  'E-Ticaret': 'E-Commerce',

  'Consulting Activities': 'Consulting Activities',
  Danışmanlık: 'Consulting Activities',

  'Real Estate Selling and Rental Services': 'Real Estate Selling and Rental Services',
  'Emlak Alım-Satım ve Kiralama Hizmetleri': 'Real Estate Selling and Rental Services',

  'Traditional and Digital Media Services': 'Traditional and Digital Media Services',
  'Geleneksel ve Dijital Medya Servisleri': 'Traditional and Digital Media Services',

  'Space and Aviation Activities': 'Space and Aviation Activities',
  'Uzay ve Havacılık Faaliyetleri': 'Space and Aviation Activities',

  'Agriculture and Farm Activities': 'Agriculture and Farm Activities',
  'Tarım ve Hayvancılık Faaliyetleri': 'Agriculture and Farm Activities',

  Logistics: 'Logistics',
  'Lojistik Faaliyetleri': 'Logistics',

  'Accounting and Financial Services': 'Accounting and Financial Services',
  'Muhasebe ve Finansal Hizmetler': 'Accounting and Financial Services',

  'Engineering and Architectural Activities': 'Engineering and Architectural Activities',
  'Mühendislik ve Mimarlık Faaliyetleri': 'Engineering and Architectural Activities',

  Tourism: 'Tourism',
  'Turizm Faaliyetleri': 'Tourism',

  'Security Services': 'Security Services',
  'Güvenlik Hizmetleri': 'Security Services',

  'Catering Services': 'Catering Services',
  'Restoran ve Yiyecek&İçecek Hizmetleri': 'Catering Services',

  'Design and Art Activities': 'Design and Art Activities',
  'Tasarım ve Sanat Faaliyetleri': 'Design and Art Activities',

  'Marketing and Advertising': 'Marketing and Advertising',
  'Pazarlama ve Reklam Faaliyetleri': 'Marketing and Advertising',

  'Construction Activities': 'Construction Activities',
  'İnşaat Faaliyetleri': 'Construction Activities',
};

export default globalActivityAreasHelper;
